<div class="navigation-rounds">
    <div *ngFor="let item of [1,2,3]; index as i"
         [class.active]="(i + 1) === activeItem"
         class="item">
    </div>
</div>
